import { ToggleGroup, tokens } from '@hotjar/hotsauce';
import type { WidgetConfig } from '@hotjar/feedback/components/common/Wizard/WidgetPreview/WidgetPreview';
import { Widget, WidgetPreview } from '@hotjar/feedback/components/common/Wizard/WidgetPreview';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { QuestionBank } from '../QuestionBank/QuestionBank';

export type Tab = 'preview' | 'bank';

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: ${tokens.spacer.x4};
  overflow: hidden;
  padding-top: ${tokens.spacer.x3};
`;

const TabPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-self: stretch;
  overflow: hidden;
`;

const WidgetPreviewWrapper = styled.div`
  margin: 0 ${tokens.spacer.x3};
`;

export interface PreviewAndQuestionBankPanelProps {
  previewConfig: WidgetConfig;
  isPopoverSurvey: boolean;
  activeTab: Tab;
  onActiveTabChange: (tab: Tab) => void;
}

export const PreviewAndQuestionBankPanel = ({
  previewConfig,
  isPopoverSurvey,
  activeTab,
  onActiveTabChange,
}: PreviewAndQuestionBankPanelProps): JSX.Element => {
  const { t } = useTranslation('feedback');
  return (
    <Container role="tablist">
      {/* TODO There is not currently a way to set Tab aria-roles for the buttons 
          We should ask DS about enhancing this component to allow different button roles */}
      <ToggleGroup
        description={t('survey-wizard.preview.question-bank-toggle.description')}
        selectedValue={activeTab}
        onChange={(value) => onActiveTabChange(value as Tab)}
      >
        <ToggleGroup.Toggle value="preview" icon="device_multiple">
          {t('survey-wizard.preview.question-bank-toggle.preview')}
        </ToggleGroup.Toggle>
        <ToggleGroup.Toggle value="bank" icon="question_cards">
          {t('survey-wizard.preview.question-bank-toggle.question-bank')}
        </ToggleGroup.Toggle>
      </ToggleGroup>
      {activeTab === 'bank' && (
        <TabPanel role="tabpanel">
          <QuestionBank />
        </TabPanel>
      )}

      {activeTab === 'preview' && (
        <TabPanel role="tabpanel">
          <WidgetPreviewWrapper>
            <WidgetPreview
              showDeviceSelector={isPopoverSurvey}
              widget={Widget.SURVEY}
              widgetConfig={previewConfig}
              iframeId="survey-preview"
            />
          </WidgetPreviewWrapper>
        </TabPanel>
      )}
    </Container>
  );
};
